'use client';

import { Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import { Link } from '@/i18n/routing';
import { DpiChecker } from '@/components/tools/dpi-checker';
import { productPath } from '@/lib/localized-paths';
import { readDpiCheckerProductSlug, readDpiCheckerTarget } from '@/lib/tools/dpi-checker-link';

/**
 * Leest `?w=&h=&product=` in de browser. Zo blijft de checkerpagina statisch
 * (searchParams op de server maakt elke aanvraag dynamisch) en kost een
 * bezoek vanaf een productpagina geen functie-aanroep.
 */
function TargetedChecker({ locale, backLabel }: { locale: string; backLabel: string }) {
  const searchParams = useSearchParams();
  const params = Object.fromEntries(searchParams.entries());
  const target = readDpiCheckerTarget(params);
  const productSlug = readDpiCheckerProductSlug(params);
  return (
    <>
      {productSlug && (
        <Link href={productPath(locale, productSlug)} className="mb-5 inline-flex items-center text-sm font-semibold text-blue-700 hover:text-blue-900">
          &larr; {backLabel}
        </Link>
      )}
      <DpiChecker locale={locale} target={target} />
    </>
  );
}

export function DpiCheckerWithTarget({ locale, backLabel }: { locale: string; backLabel: string }) {
  return (
    <Suspense fallback={<DpiChecker locale={locale} />}>
      <TargetedChecker locale={locale} backLabel={backLabel} />
    </Suspense>
  );
}
